<template>
  <el-dialog v-model="innerVisible" :title="detailId ? '修改商户信息' : '申请入驻'" width="1400px" align-center
    class="merchant-dialog">
    <div class="hint">请填写以下信息完成商家入驻申请，所有字段均为必填。提交后我们将在 1-3 个工作日内核您的申请，请保持联系畅通</div>
    <el-form ref="formRef" :model="form" :rules="rules" label-position="top" class="form">
      <div class="section">
        <div class="section-title">基本信息</div>
        <div class="grid four">
          <el-form-item label="商家名称 *" prop="name">
            <el-input v-model="form.name" placeholder="请输入商家名称" />
          </el-form-item>
          <el-form-item label="省市区 *" prop="region">
            <el-cascader ref="regionRef" v-model="form.region" :options="regionOptions" style="width: 100%"
              :props="{ value: 'code', label: 'name', children: 'children', emitPath: true }" filterable
              placeholder="请选择省/市/区">
              <template #label="{ node, data }">
                {{ data.name }}
                {{ node }}
              </template>
            </el-cascader>
          </el-form-item>
          <el-form-item label="联系人 *" prop="contact">
            <el-input v-model="form.contact" placeholder="请输入联系人姓名" />
          </el-form-item>
          <el-form-item label="详细地址 *" prop="address">
            <el-input v-model="form.address" placeholder="请输入详细经营地址" />
          </el-form-item>
        </div>
        <div class="grid ">
          <el-form-item label="平台用户名 *" prop="platform_user_name">
            <el-input v-model="form.platform_user_name" placeholder="请输入平台用户名" />
          </el-form-item>
          <el-form-item label="身份证号 *" prop="id_card">
            <el-input v-model="form.id_card" placeholder="请输入身份证号" />
          </el-form-item>
        </div>

        <el-form-item label="商家描述 *" prop="desc">
          <el-input v-model="form.desc" type="textarea" :rows="5" maxlength="500" show-word-limit
            placeholder="请简要描述商家主营业务、特色产品或服务等信息" />
        </el-form-item>

      </div>
      <div class="grid">
        <div class="section">
          <div class="section-title">身份证照片</div>
          <div class="grid two">
            <el-form-item label="身份证正面 *" prop="id_card_front">
              <el-upload class="uploader" drag :show-file-list="false" style="width: 100%"
                :before-upload="handleIdCardFrontBefore" :http-request="handleIdCardFrontUpload">
                <div class="upload-card" v-loading="idCardFrontUploading" element-loading-text="上传中..."
                  element-loading-background="rgba(255,255,255,0.6)">
                  <template v-if="form.idCardFrontUrl">
                    <img :src="form.idCardFrontUrl" class="upload-preview" />
                  </template>
                  <template v-else>
                    <div class="upload-icon">
                      <el-icon>
                        <Upload />
                      </el-icon>
                    </div>
                    <div class="upload-text-main">点击上传或拖放文件至此处</div>
                    <div class="upload-text-sub">支持 PNG、JPG 格式</div>
                  </template>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="身份证背面 *" prop="id_card_back">
              <el-upload class="uploader" drag :show-file-list="false" style="width: 100%"
                :before-upload="handleIdCardBackBefore" :http-request="handleIdCardBackUpload">
                <div class="upload-card" v-loading="idCardBackUploading" element-loading-text="上传中..."
                  element-loading-background="rgba(255,255,255,0.6)">
                  <template v-if="form.idCardBackUrl">
                    <img :src="form.idCardBackUrl" class="upload-preview" />
                  </template>
                  <template v-else>
                    <div class="upload-icon">
                      <el-icon>
                        <Upload />
                      </el-icon>
                    </div>
                    <div class="upload-text-main">点击上传或拖放文件至此处</div>
                    <div class="upload-text-sub">支持 PNG、JPG 格式</div>
                  </template>
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
        <div class="section">
          <div class="section-title">资质证明</div>
          <div class="grid two">
            <el-form-item label="商家Logo *" prop="logo">
              <el-upload class="uploader" drag :show-file-list="false" style="width: 100%"
                :before-upload="handleLogoBefore" :http-request="handleLogoUpload">
                <div class="upload-card" v-loading="logoUploading" element-loading-text="上传中..."
                  element-loading-background="rgba(255,255,255,0.6)">
                  <template v-if="form.logoUrl">
                    <img :src="form.logoUrl" class="upload-preview" />
                  </template>
                  <template v-else>
                    <div class="upload-icon">
                      <el-icon>
                        <Upload />
                      </el-icon>
                    </div>
                    <div class="upload-text-main">点击上传或拖放文件至此处</div>
                    <div class="upload-text-sub">支持 PNG、JPG 格式</div>
                  </template>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="营业执照 *" prop="license">
              <el-upload class="uploader" drag :show-file-list="false" style="width: 100%"
                :before-upload="handleLicenseBefore" :http-request="handleLicenseUpload">
                <div class="upload-card" v-loading="licenseUploading" element-loading-text="上传中..."
                  element-loading-background="rgba(255,255,255,0.6)">
                  <template v-if="form.licenseUrl">
                    <img :src="form.licenseUrl" class="upload-preview" />
                    <!-- <div v-else class="upload-file-name">{{ form.licenseName || '已上传文件' }}</div> -->
                  </template>
                  <template v-else>
                    <div class="upload-icon">
                      <el-icon>
                        <Upload />
                      </el-icon>
                    </div>
                    <div class="upload-text-main">点击上传或拖放文件至此处</div>
                    <div class="upload-text-sub">支持 PNG、JPG格式</div>
                  </template>
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
      </div>

    </el-form>
    <template #footer>
      <div class="footer-actions">
        <el-button @click="onCancel">取消</el-button>
        <!-- <el-button type="primary" plain @click="onSave">保存草稿</el-button> -->
        <el-button type="primary" @click="onSubmit">{{ detailId ? '修改商户信息' : '提交申请' }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script lang="ts" setup>
import { ref, reactive, computed, watch, onMounted } from 'vue'
import { ElDialog, ElButton, ElForm, ElFormItem, ElInput, ElSelect, ElOption, ElUpload, ElMessage, ElIcon, ElCascader } from 'element-plus'
//@ts-ignore
import areaData from '@/common/area.json'
import { Upload } from '@element-plus/icons-vue'
import { uploadfiles } from '@/api/plugin'
import { businessApply, uploadImage, getDesignerApplyDict, editBusinessDetail } from '@/api/match'
const props = defineProps<{ visible: boolean, businessDetail: Record<string, any> }>()
const emit = defineEmits(['update:visible', 'save', 'submit'])
const innerVisible = computed({
  get: () => props.visible,
  set: v => emit('update:visible', v)
})
watch(() => props.visible, (newVal) => {
  if (newVal) {
    console.log('qweqweqew')
    let businessDetail = props.businessDetail || {}
    restoreForm(businessDetail)
  }
})
watch(() => props.businessDetail, (bd) => {
  if (innerVisible.value) {
    restoreForm(bd || {})
  }
}, { deep: true })
const formRef = ref()
const form = reactive({ name: '', region: [] as Array<string | number>, contact: '', platform_user_name: '', id_card: '', desc: '', address: '', logo: null as File | null, license: null as File | null, id_card_front: null as File | null, id_card_back: null as File | null, logoUrl: '', licenseUrl: '', licenseType: '', licenseName: '', idCardFrontUrl: '', idCardBackUrl: '' })
const logoUploading = ref(false)
const licenseUploading = ref(false)
const idCardFrontUploading = ref(false)
const idCardBackUploading = ref(false)
const regionOptions = ref<any[]>([])
const regionRef = ref()
const detailId = ref('')
const restoreForm = (bd: Record<string, any> = {}) => {
  console.log(bd)
  form.name = bd.company_name || bd.customer_name || ''
  form.contact = bd.contact_person || ''
  form.platform_user_name = bd.platform_user_name || ''
  form.id_card = bd.id_card || ''
  form.address = bd.address || ''
  form.desc = bd.introduce || ''
  form.logo = bd.logo || null
  form.id_card_front = bd.id_card_front || null
  form.id_card_back = bd.id_card_back || null
  form.logoUrl = bd.logo || ''
  form.licenseUrl = bd.license || ''
  form.license = bd.license || ''
  form.idCardFrontUrl = bd.id_card_front || ''
  form.idCardBackUrl = bd.id_card_back || ''
  const codes = [bd.province_code, bd.city_code, bd.district_code].filter(Boolean)
  form.region = codes as Array<string | number>
  detailId.value = bd.id || ''
}

const rules = {
  name: [{ required: true, message: '请输入商家名称', trigger: 'blur' }],
  region: [{ required: true, message: '请选择省市区', trigger: 'change' }],
  contact: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
  platform_user_name: [{ required: true, message: '请输入平台用户名', trigger: 'blur' }],
  id_card: [{ required: true, message: '请输入身份证号', trigger: 'blur' }],
  desc: [{ required: true, message: '请输入商家描述', trigger: 'blur' }],
  address: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
  logo: [{ required: true, message: '请上传商家 Logo', trigger: 'change' }],
  license: [{ required: true, message: '请上传营业执照', trigger: 'change' }],
  id_card_front: [{ required: true, message: '请上传身份证正面', trigger: 'change' }],
  id_card_back: [{ required: true, message: '请上传身份证背面', trigger: 'change' }]
}
const readImageSize = (file: File) => new Promise<{ w: number, h: number }>((resolve, reject) => {
  const url = URL.createObjectURL(file)
  const img = new Image()
  img.onload = () => { resolve({ w: img.width, h: img.height }); URL.revokeObjectURL(url) }
  img.onerror = () => { reject(); URL.revokeObjectURL(url) }
  img.src = url
})
const handleLogoBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG 格式'); return false }
  const size = await readImageSize(file)
  if (size.w < 200 || size.h < 200) { ElMessage.error('尺寸需不小于 200×200px'); return false }
  return true
}
const handleLogoUpload = async (option: any) => {
  logoUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.logo = raw
      form.logoUrl = url
    }
    console.log('logoUrl', form.logoUrl)
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    logoUploading.value = false
  }
}
const handleLicenseBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg', 'application/pdf'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG、PDF 格式'); return false }
  return true
}
const handleLicenseUpload = async (option: any) => {
  licenseUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.license = raw
      form.licenseUrl = url
      form.licenseType = raw?.type || ''
      form.licenseName = raw?.name || ''
    }
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    licenseUploading.value = false
  }
}
const handleIdCardFrontBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG 格式'); return false }
  return true
}
const handleIdCardFrontUpload = async (option: any) => {
  idCardFrontUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.id_card_front = raw
      form.idCardFrontUrl = url
    }
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    idCardFrontUploading.value = false
  }
}
const handleIdCardBackBefore = async (file: File) => {
  const okType = ['image/png', 'image/jpeg'].includes(file.type)
  if (!okType) { ElMessage.error('仅支持 PNG、JPG 格式'); return false }
  return true
}
const handleIdCardBackUpload = async (option: any) => {
  idCardBackUploading.value = true
  try {
    const raw: File = option?.file?.raw || option?.file
    const fd = new FormData()
    fd.append('file', raw, raw?.name || 'file')
    const res = await uploadImage(fd)
    const url = res?.data?.data?.url || ''
    if (url) {
      form.id_card_back = raw
      form.idCardBackUrl = url
    }
    option?.onSuccess?.(res?.data, option?.file)
  } catch (e) {
    option?.onError?.(e)
    ElMessage.error('上传失败')
  } finally {
    idCardBackUploading.value = false
  }
}
const onCancel = () => { emit('update:visible', false) }
const onSave = () => { emit('save', { ...form }) }
const onSubmit = () => {
  formRef.value?.validate((valid: boolean) => {
    if (valid) {
      const codes: (string | number)[] = Array.isArray(form.region) ? form.region : [form.region].filter(Boolean)
      let names: string[] = []
      try {
        const node = regionRef.value?.getCheckedNodes?.()[0]
        names = Array.isArray(node?.pathLabels) ? node.pathLabels : []

      } catch { }

      const payload = {
        user_type: 1,
        company_name: form.name,
        // customer_name: form.name,
        contact_person: form.contact,
        platform_user_name: form.platform_user_name,
        id_card: form.id_card,
        id_card_front: form.idCardFrontUrl || '',
        id_card_back: form.idCardBackUrl || '',
        logo: form.logoUrl || '',
        license: form.licenseUrl || '',
        province_code: codes[0] || '',
        city_code: codes[1] || '',
        district_code: codes[2] || '',
        province_name: names[0] || '',
        city_name: names[1] || '',
        district_name: names[2] || '',
        address: form.address,
        introduce: form.desc,
        origin_type: 2
      }
      let api = businessApply
      if (detailId.value) {
        (payload as Record<string, any>).id = detailId.value
        api = editBusinessDetail
      }
      console.log(payload)
      api(payload).then(res => {
        if (res?.data?.code === 200) {
          ElMessage.success(res?.data?.message || '申请成功')
          innerVisible.value = false
          window.location.reload()
        }

        // onCancel()
      })
    }
  })
}

onMounted(() => {
  loadRegionOptions()
  getopt()
})

const professionalOptions = ref([])
const experienceOptions = ref([])
const loadRegionOptions = async () => {
  regionOptions.value = areaData
}
const getopt = async () => {
  let po = await getDesignerApplyDict({ parent_id: '46' })
  let eo = await getDesignerApplyDict({ parent_id: '43' })
  professionalOptions.value = po?.data?.data || []
  experienceOptions.value = eo?.data?.data || []
}


</script>
<style lang="scss" scoped>
.merchant-dialog :deep(.el-dialog__body) {
  padding: 0 0 16px 0;
}

.merchant-dialog :deep(.el-dialog__header) {
  border-bottom: 1px solid #eef1f5;
}

.hint {
  background: #edf4ff;
  color: #4b6b9f;
  border: 1px solid #dbe7ff;
  padding: 12px 16px;
  margin: 16px;
  border-radius: 8px;
  font-size: 12px;
}

.form {
  padding: 0 16px 8px;
}

.section {
  background: #fff;
  border: 1px solid #eef1f5;
  border-radius: 12px;
  padding: 16px;
  margin: 16px;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2328;
  margin-bottom: 12px;
}

.grid {
  display: grid;
  gap: 12px;
}

.grid.two {
  grid-template-columns: 1fr 1fr;
}

.grid.four {
  grid-template-columns: 1fr 1fr 1fr 1fr;
}

.uploader :deep(.el-upload) {
  width: 100%;
}

.upload-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 160px;
  border-radius: 10px;
  position: relative;
}

.upload-preview {
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: 10px;
}

.upload-file-name {
  font-size: 13px;
  color: #38393b;
}

.upload-icon :deep(svg) {
  width: 28px;
  height: 28px;
  color: #2a66ff;
}

.upload-text-main {
  font-size: 14px;
  color: #38393b;
}

.upload-text-sub {
  font-size: 12px;
  color: #8a8f99;
}

.footer-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 0 8px;
}

:deep(.el-input__wrapper),
:deep(.el-textarea__inner) {
  border-radius: 8px;
}

:deep(.el-input__wrapper.is-focus),
:deep(.el-select .el-input__wrapper.is-focus),
:deep(.el-textarea__inner:focus) {
  border-color: #2a66ff !important;
  box-shadow: 0 0 0 1px rgba(42, 102, 255, 0.2);
}
</style>
<style>
.el-upload-dragger {
  padding: 0 !important;
}
</style>
